module.exports = __webpack_public_path__ + "img/resort.df415a7b.png";